export const DEFAULT_AI_MODEL = "openai/gpt-oss-20b";

/** Groq-decommissioned model IDs → current replacements (keep in sync with server/src/utils/groqModels.js). */
export const LEGACY_AI_MODEL_MAP = {
  "llama-3.1-8b-instant": "openai/gpt-oss-20b",
  "llama-3.3-70b-versatile": "openai/gpt-oss-120b",
  "llama-3.3-70b-specdec": "openai/gpt-oss-120b",
  "llama3-8b-8192": "openai/gpt-oss-20b",
  "llama3-70b-8192": "openai/gpt-oss-120b",
  "llama-3.1-70b-versatile": "openai/gpt-oss-120b",
  "meta-llama/llama-4-scout-17b-16e-instruct": "openai/gpt-oss-120b",
  "moonshotai/kimi-k2-instruct": "openai/gpt-oss-120b",
  "moonshotai/kimi-k2-instruct-0905": "openai/gpt-oss-120b",
  "deepseek-r1-distill-llama-70b": "openai/gpt-oss-120b",
};

export function resolveAiModel(value) {
  if (!value) return DEFAULT_AI_MODEL;
  return LEGACY_AI_MODEL_MAP[value] || value;
}

export const AI_MODEL_OPTIONS = [
  {
    value: "openai/gpt-oss-20b",
    label: "GPT-OSS 20B",
    hint: "Default · fastest",
  },
  {
    value: "openai/gpt-oss-120b",
    label: "GPT-OSS 120B",
    hint: "Highest quality",
  },
  {
    value: "qwen/qwen3.6-27b",
    label: "Qwen 3.6 27B",
    hint: "Balanced quality",
  },
];

export function getAiModelLabel(value) {
  const resolved = resolveAiModel(value);
  return (
    AI_MODEL_OPTIONS.find((o) => o.value === resolved)?.label ||
    resolved ||
    "GPT-OSS 20B"
  );
}

export function getAiModelTierBadge(value) {
  const resolved = resolveAiModel(value);
  if (!resolved || resolved === DEFAULT_AI_MODEL) return null;
  if (/120b|70b|27b/i.test(resolved)) return "Pro";
  return null;
}
